import { Map, fromJS } from 'immutable'
import * as actions from './actions'

export const initialState = Map()

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actions.SET_UPDATE_PAYMENT_ORDER_PROCESSING:
      return state.set('processing', action.payload)
    case actions.SET_UPDATE_PAYMENT_ORDER_ERROR:
      return state.withMutations((mutateState) => mutateState
        .set('orderError', action.payload)
        .delete('processing'))
    case actions.SET_UPDATE_PAYMENT_ORDER_DATA:
      return state.set('orderData', fromJS(action.payload))
    case actions.SET_UPDATE_PAYMENT_ORDER_COMPLETE:
      return state.withMutations((mutateState) => (mutateState
        .set('orderComplete', action.payload)
        // Clean up
        .delete('orderData')
        .delete('orderError')
      ))
    case actions.RESET_UPDATE_PAYMENT:
      return initialState
    default:
      return state
  }
}
